export const totalCorrectQuizzes = (quizzes, selectedOptions) => {
  const correctAnswers = quizzes?.map((quiz) => {
    const correctOptions = quiz?.options?.filter((option) => {
      return option.isCorrect;
    });
    const correctOptionsId = correctOptions?.map((correctOption) => {
      return correctOption.id;
    });
    return {
      quizId: quiz.id,
      correctAnswersId: correctOptionsId,
    };
  });

  const totalCorrectQuiz = correctAnswers?.reduce((prevTotal, ans) => {
    const sortedSelectedOption = selectedOptions
      ?.find((option) => option.quizId === ans?.quizId)
      ?.selectedOptionsId?.sort();

    const sortedSelectedAns = ans?.correctAnswersId.sort();

    const areEqual =
      JSON.stringify(sortedSelectedOption) ===
      JSON.stringify(sortedSelectedAns);

    if (areEqual) {
      return prevTotal + 1;
    }
    return prevTotal;
  }, 0);

  return totalCorrectQuiz;
};
